module.exports = "/images/vendor/desiigner-svg/svg/ui/faux-right-arrow.svg?195f6bde6579538f2fa9f50275725f14";